package pt.at.oss.kotlin.manual.time

import com.soywiz.klock.DateFormat
import com.soywiz.klock.DateTime
import com.soywiz.klock.Month
import pt.lightweightform.kotlin.schema.DateStringSchema

/**
 * Created by Pedro Alfaiate on 15/05/2020.
 */

val OSS_START_DATE = DateTime(2021, Month.July, 1)

fun parseDate(dateStr: String): DateTime {
    // Note: We are explicitly trimming because LF always sends dates as 'yyyy-MM-ddThh:mm:ss.SSSZ'.
    val trimmedDateStr = dateStr.substring(0, DateStringSchema.DEFAULT_DATE_FORMAT.length)
    return DateFormat(DateStringSchema.DEFAULT_DATE_FORMAT).tryParse(trimmedDateStr, true)!!.local
}

fun formatDate(dateTime: DateTime): String {
    return DateFormat(DateStringSchema.DEFAULT_DATE_FORMAT).format(dateTime.localUnadjusted)
}
